import { getCoreRowModel, getSortedRowModel, type SortingState, useReactTable } from '@tanstack/react-table'
import { useMemo, useRef, useState } from 'react'
import { Table } from './Table'
import { findTable } from './tables/findTable'
import { useQuery } from 'react-query'
import { fetchImprovedTableData } from '../../../../api/newApi'
import { useChosenCompany, useUser } from '../../../../context/UserProvider'
import { RightAlignedRow } from '../../../../theme/Theme.ItemGroup'
import { ExcelExportButton } from '../../../reports/v3/components/ExcelExporter'
import { findColumns } from './tables/findColumns'
import { formatDate, formatTime } from '../V3/helpers/formatDate'

export function CarDetailTables({ id, filter, fromDate, toDate }) {
  const [sorting, setSorting] = useState<SortingState>([])
  const user = useUser()
  const company = useChosenCompany()
  const companyId = company?.id

  const columns = useMemo(() => findTable(filter), [filter])

  const {
    data = [],
    isFetching,
  }: {
    data: any
    isLoading: boolean
    isFetching: boolean
    refetch: any
  } = useQuery({
    queryKey: ['table', filter, id, fromDate, toDate],
    queryFn: () =>
      fetchImprovedTableData({
        account: id,
        fromDate: fromDate.toISOString(),
        toDate: toDate.toISOString(),
        productType: filter,
        companyId: companyId,
        contactId: user?.user.id,
      }),
    keepPreviousData: true,
  })

  const tableContainerRef = useRef<HTMLDivElement>(null)
  const table = useReactTable({
    data: data,
    columns: columns,
    initialState: {
      pagination: null,
    },
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  })

  const mappedData = useMemo(() => {
    return data?.map((cost) => {
      const { date: rawDate, ...rest } = cost
      const date = formatDate(rawDate)
      const time = formatTime(rawDate)

      return { ...rest, date, time }
    })
  }, [data])

  return (
    <div className="flex flex-col">
      <div className="z-20">
        <RightAlignedRow>
          <ExcelExportButton
            data={mappedData}
            config={{
              columns: findColumns(filter),
              filename: `Report-${filter}-${id}.xlsx`,
              sheetName: 'Car Cost Report',
            }}
          />
        </RightAlignedRow>
      </div>
      <div className="flex-1 relative">
        <Table table={table} isLoading={isFetching} tableContainerRef={tableContainerRef} />
      </div>
    </div>
  )
}
